(() => {
  angular.module('pims').filter('humanizeStatus', ["Auth", Auth => {
    'ngInject';

    return order => {
      if (!Auth.profile) {
        return '';
      }

      var order2 = new Order(order);

      if (order2.isLocked()) {
        return `Locked by Dr. ${order.locked_by.lastname}`;
      }

      try {
        return order2.getStatus();
      } catch (e) {
        throw new Error('We do not know this status! Please add it to Constants.');
      }
    };
  }]);
})();
